const BASE_PATH = "https://flex-dev-dev-gateway.dev.grapeisfruit.com".replace(/\/+$/, "");
class RequiredError extends Error {
  constructor(field, msg) {
    super(msg);
    this.field = field;
    this.name = "RequiredError";
  }
}

export { BASE_PATH, RequiredError };
//# sourceMappingURL=base.mjs.map
